import { AnalyticsBrandSettings, AnalyticsEventData } from 'idt-analytics-api/models';
import { getDefaultAnalytics } from '../helpers/events.helper';
import { AnalyticsGTMSettings, DefaultAnalyticsSettings } from 'analytics-api';
import { AnalyticsOyshoEventDataHelpers } from '../helpers/brand-analytics-event-data.helpers.oy';

export const WorldWideEvents: AnalyticsBrandSettings = {

  worldWideConfiguracionAccederOk(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'configuracion', 'worldwide', 'acceder_ok');
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  worldWideConfiguracionSeleccionarIdioma(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData } = data;
    const language = componentData.language;
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'configuracion', 'worldwide', 'seleccionar_idioma', language);
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  worldWideConfiguracionSeleccionarRegion(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData } = data;
    const country = componentData.country;
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'configuracion', 'worldwide', 'seleccionar_region', country);
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },
};
